import { withAuthenticationRequired } from '@tom-ui/utils'
import { ReportsContainer } from '@billing/features/reports/containers/ReportsContainer'
import { useTranslate } from '@tolgee/react'
import { FC } from 'react'
import { Helmet } from 'react-helmet-async'

const Reports: FC = withAuthenticationRequired(() => {
  const { t } = useTranslate()

  return (
    <>
      <Helmet>
        <title>{t('ReportsTomBillingService', 'Reports - TOM Billing Service')}</title>
      </Helmet>

      <ReportsContainer />
    </>
  )
})

export default Reports
